import { css } from 'styled-system/css';
import { FeatureMockup } from '../featureMockups';
import type { Feature } from './types';

export function FeatureSlide({
  feature,
  index,
  active,
}: {
  feature: Feature;
  index: number;
  active: boolean;
}) {
  return (
    <article
      id={feature.id}
      data-feature-index={index}
      aria-current={active ? 'true' : undefined}
      className={css({
        minHeight: { base: 'auto', md: '180vh' },
        paddingBlock: { base: '10', md: '0' },
        scrollMarginTop: '32',
      })}
    >
      <div
        data-active={active || undefined}
        className={css({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          position: { md: 'sticky' },
          top: '48',
          opacity: { base: 1, md: 0.28 },
          transition: 'opacity 500ms {easings.out}',
          _motionReduce: { transition: 'none' },
          '&[data-active]': { opacity: 1 },
        })}
      >
        <h2
          className={css({
            fontFamily: 'sans',
            fontWeight: 'bold',
            fontSize: { base: '2xl', md: '3xl' },
            letterSpacing: 'tight',
            lineHeight: 'tight',
            color: 'text.primary',
            maxWidth: '16ch',
          })}
        >
          {feature.title}
        </h2>
        <p
          className={css({
            fontSize: { base: 'sm', md: 'base' },
            lineHeight: 'relaxed',
            color: 'text.secondary',
            maxWidth: '38ch',
            marginTop: '4',
            paddingBottom: '8',
          })}
        >
          {feature.body}
        </p>
        <div
          aria-hidden="true"
          className={css({
            display: { base: 'block', md: 'none' },
            marginTop: '8',
            height: '240px',
          })}
        >
          <FeatureMockup feature={feature.id} active={active} />
        </div>
      </div>
    </article>
  );
}
